import { useState } from "react";
import heroBg from "@/assets/hero-bg-hq-1200.webp";
import heroBgSmall from "@/assets/hero-bg-hq-800.webp";
import heroBgTiny from "@/assets/hero-bg-hq-480.webp";
import AvailabilityModal, { preloadAvailabilityModal } from "@/components/home/LazyAvailabilityModal";


const HeroSection = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <section
      id="main-content"
      className="relative min-h-screen flex items-center justify-center bg-brand-obsidian overflow-hidden"
      aria-label="Hero — Premium Mobile Restrooms"
    >
      {/* Hero background image */}
      <div className="absolute inset-0">
        <img
          src={heroBg}
          srcSet={`${heroBgTiny} 480w, ${heroBgSmall} 800w, ${heroBg} 1200w`}
          sizes="100vw"
          alt=""
          width={1200}
          height={896}
          className="w-full h-full object-cover"
          loading="eager"
          decoding="async"
          // @ts-ignore
          fetchpriority="high"
          role="presentation"
        />
      </div>

      {/* Warm brand tint + gradient to match the site palette */}
      <div
        className="absolute inset-0 pointer-events-none bg-gradient-to-b from-brand-obsidian/45 via-brand-obsidian/25 to-brand-obsidian/55"
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 pointer-events-none bg-[#c7a03d]/[0.14] mix-blend-multiply"
        aria-hidden="true"
      />

      <div
        className="relative z-10 px-5 sm:px-6 md:px-12 max-w-3xl mx-auto text-left bg-brand-obsidian/40 backdrop-blur-md rounded-2xl border border-white/10 p-6 sm:p-8 md:p-12 space-y-4 sm:space-y-6"
      >
        <p className="section-label text-base sm:text-lg text-white">
          Premium Mobile Restrooms
        </p>
        <h1 className="text-brand-parchment leading-[1.08] tracking-[-0.02em] text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
          Clean, Reliable Restroom Trailer Rentals in Nevada
        </h1>
        <p className="font-sans text-sm sm:text-base md:text-lg max-w-xl leading-relaxed font-light text-primary-foreground">
          Luxury and ADA-compliant restroom trailers for weddings, filming sites, and private events—delivered on time and set up right.
        </p>
        <button
          onClick={() => setModalOpen(true)}
          onMouseEnter={preloadAvailabilityModal}
          onFocus={preloadAvailabilityModal}
          className="inline-flex items-center px-6 sm:px-8 py-3 sm:py-3.5 bg-primary text-primary-foreground text-[11px] tracking-[0.14em] uppercase font-sans font-semibold rounded-pill hover:shadow-brand-gold hover:-translate-y-px active:scale-[0.97] transition-all"
          aria-label="Check availability for restroom trailer rental"
        >
          Check Availability
        </button>
      </div>

      <AvailabilityModal
        ctaSource="home_hero" open={modalOpen} onOpenChange={setModalOpen} />
    </section>
  );
};

export default HeroSection;
